var _path, _path2, _path3, _path4, _circle, _circle2, _path5, _circle3, _circle4, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfirm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 82,
    viewBox: "0 0 100 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.01756 11.7234L6.80771 13.8657C6.83742 13.9464 6.91421 13.9999 7.00006 13.9999C7.08591 13.9999 7.1627 13.9464 7.19241 13.8657L7.98256 11.7234C8.62215 9.98898 9.98934 8.62178 11.7236 7.98232L13.866 7.19216C13.9465 7.16246 14 7.08567 14 6.99982C14 6.91397 13.9465 6.83717 13.866 6.80747L11.7235 6.01732C9.98922 5.37773 8.62203 4.01066 7.98256 2.2764L7.19241 0.134027C7.1627 0.05349 7.08591 0 7.00006 0C6.91421 0 6.83742 0.05349 6.80771 0.134027L6.01756 2.2764C5.37797 4.01066 4.0109 5.37773 2.27652 6.01732L0.134027 6.80747C0.05349 6.83717 0 6.91397 0 6.99982C0 7.08567 0.05349 7.16246 0.134027 7.19216L2.2764 7.98232C4.01078 8.62178 5.37797 9.98886 6.01756 11.7234Z",
    fill: "#8D50F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29826 74.3738L8.86265 75.9041C8.88387 75.9617 8.93872 75.9999 9.00004 75.9999C9.06136 75.9999 9.11622 75.9617 9.13743 75.9041L9.70183 74.3738C10.1587 73.135 11.1352 72.1584 12.374 71.7017L13.9043 71.1373C13.9618 71.116 14 71.0612 14 70.9999C14 70.9385 13.9618 70.8837 13.9043 70.8625L12.3739 70.2981C11.1352 69.8412 10.1586 68.8648 9.70183 67.626L9.13743 66.0957C9.11622 66.0382 9.06136 66 9.00004 66C8.93872 66 8.88387 66.0382 8.86265 66.0957L8.29826 67.626C7.84141 68.8648 6.86493 69.8412 5.62609 70.2981L4.09573 70.8625C4.03821 70.8837 4 70.9385 4 70.9999C4 71.0612 4.03821 71.116 4.09573 71.1373L5.626 71.7017C6.86484 72.1584 7.84141 73.1349 8.29826 74.3738Z",
    fill: "#8D50F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0088 21.8617L94.4039 22.9329C94.4187 22.9733 94.4571 23 94.5 23C94.543 23 94.5814 22.9733 94.5962 22.9329L94.9913 21.8617C95.3111 20.9945 95.9947 20.3109 96.8618 19.9912L97.933 19.5961C97.9733 19.5813 98 19.5429 98 19.4999C98 19.457 97.9733 19.4186 97.933 19.4038L96.8617 19.0087C95.9946 18.6889 95.311 18.0053 94.9913 17.1382L94.5962 16.067C94.5814 16.0267 94.543 16 94.5 16C94.4571 16 94.4187 16.0267 94.4039 16.067L94.0088 17.1382C93.689 18.0053 93.0055 18.6889 92.1383 19.0087L91.067 19.4038C91.0267 19.4186 91 19.457 91 19.4999C91 19.5429 91.0267 19.5813 91.067 19.5961L92.1382 19.9912C93.0054 20.3109 93.689 20.9945 94.0088 21.8617Z",
    fill: "#8D50F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1579 70.0486L93.8352 71.8849C93.8606 71.954 93.9265 71.9999 94.0001 71.9999C94.0736 71.9999 94.1395 71.954 94.1649 71.8849L94.8422 70.0486C95.3904 68.562 96.5623 67.3901 98.0488 66.842L99.8851 66.1647C99.9542 66.1393 100 66.0734 100 65.9998C100 65.9263 99.9542 65.8604 99.8851 65.835L98.0487 65.1577C96.5622 64.6095 95.3903 63.4377 94.8422 61.9512L94.1649 60.1149C94.1395 60.0458 94.0736 60 94.0001 60C93.9265 60 93.8606 60.0458 93.8352 60.1149L93.1579 61.9512C92.6097 63.4377 91.4379 64.6095 89.9513 65.1577L88.1149 65.835C88.0458 65.8604 88 65.9263 88 65.9998C88 66.0734 88.0458 66.1393 88.1149 66.1647L89.9512 66.842C91.4378 67.3901 92.6097 68.5619 93.1579 70.0486Z",
    fill: "#FFCD01"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 41.5,
    r: 40.5,
    fill: "#F0FCF7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 41,
    r: 22,
    fill: "#04C17D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1666 36.3462L46.6249 46.4295L41.8333 41.8462",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 41.5,
    r: 40.5,
    fill: "#F0FCF7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 41,
    r: 22,
    fill: "#04C17D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1666 36.3462L46.6249 46.4295L41.8333 41.8462",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirm);
export default __webpack_public_path__ + "static/media/confirm.99e533a23c58c6ee0746e407ec3b60f1.svg";
export { ForwardRef as ReactComponent };